import React, { useContext } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

// Selectors:
import {
  getLinkedDepartures,
  getLinkedOperators,
} from '../../domain/state/linked/selectors';
import { getHasHotels } from '../../domain/state/hotels/selectors';

// Context:
import { MobileContext } from '../../domain/context/MobileContext';
import { List } from '../components/List/List';
import { modifierStylesSelector } from '../../domain/state/modifier/selectors';

const mapStateToProps = (state) => ({
  linkedDepartures: getLinkedDepartures(state),
  linkedOperators: getLinkedOperators(state),
  hasHotels: getHasHotels(state),
  modifierStyles: modifierStylesSelector(state),
});

export const DepartureContainer = connect(mapStateToProps)((props) => {
  const { linkedDepartures, linkedOperators, hasHotels, modifierStyles } =
    props;
  const isMobile = useContext(MobileContext);

  if (!hasHotels) {
    return null;
  }

  const departuresAndOperators = [
    {
      name: 'Туроператор',
      linked: linkedOperators,
      showMoreLabel: 'Показать всех туроператоров',
    },
    {
      name: 'Вылеты из городов',
      linked: linkedDepartures,
      showMoreLabel: 'Показать все города',
    },
  ];

  return (
    <StyledContainer isMobile={isMobile}>
      {departuresAndOperators.map((list) => {
        const { name, linked, showMoreLabel } = list;

        if (isEmpty(linked)) {
          return null;
        }

        return (
          <Wrapper key={name}>
            <Label boldTextColor={modifierStyles.boldTextColor}>{name}</Label>
            <List
              list={linked}
              isMobile={isMobile}
              showMoreLabel={showMoreLabel}
              modifierStyles={modifierStyles}
            />
          </Wrapper>
        );
      })}
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  margin-top: ${({ isMobile }) => (isMobile ? 12 : 22)}px;
  padding-bottom: ${({ isMobile }) => (isMobile ? 70 : 8)}px;
  display: flex;
  width: ${({ isMobile }) => (isMobile ? '100%' : '220px')};
  flex-direction: column;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 12px;
  }
`;

const Label = styled.p`
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;

  ${({ boldTextColor }) => boldTextColor && `color: ${boldTextColor}`};
`;
